function noop() { }

export { noop as default };
